import React, { useRef } from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from '../../../hooks'
import { generateHtmlId } from '../../../utils'

const Text = ({ label, value }) => {
  const { i18n } = useTranslation();
  const { current: id } = useRef(generateHtmlId());
  return value ? (
    <div>
      {label && <label className="field__label" htmlFor={id}>{i18n(label)}</label>}
      <div className="field" dangerouslySetInnerHTML={{__html: i18n(value) }} />
    </div>
  ) : null
}

Text.propTypes = {
  text: PropTypes.string
}

export default Text
